"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineRadioGroupCSS = exports.SingleRadioToolbox = void 0;
var SingleRadioToolbox = function SingleRadioToolbox(Survey, SingleQuestionRadiogroupModel) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (x) {
    return x;
  };
  var isAddDefault = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var widget = {
    name: 'singleradio',
    title: 'Text with singleradio',
    iconName: '',
    widgetIsLoaded: function widgetIsLoaded() {
      return true;
    },
    isFit: function isFit(question) {
      return question.getType() === 'radiogroup';
    },
    init: function init() {
      Survey.Serializer.addClass('singleradio', [
      // general
      {
        name: '!name',
        displayName: t('Field ID'),
        category: 'general',
        visibleIndex: 0
      }, {
        name: 'title:input',
        displayName: t('Field Name'),
        category: 'general',
        visibleIndex: 1
      }, {
        name: 'description:input',
        displayName: t('Field Description'),
        maxLength: 160,
        category: 'general',
        visibleIndex: 2,
        descriptionPlaceHolder: 'otherPlaceHolder'
      }, {
        name: 'visible',
        displayName: t('Is this field visible?'),
        default: true,
        category: 'general'
      }, {
        name: 'isRequired',
        displayName: t('Is this field required?'),
        default: false,
        category: 'general'
      }, {
        name: 'readOnly',
        displayName: t('Is this field read only?'),
        default: false,
        category: 'general'
      },
      // choices
      {
        name: 'hasOther',
        displayName: t('Add an ‘Other’ item?'),
        default: false,
        category: 'choices',
        visibleIndex: 3
      }, {
        name: 'otherText',
        displayName: 'Other Item Text',
        category: 'choices',
        visibleIndex: 4,
        type: 'dependencyItemCustom'
      }, {
        name: 'hasNone',
        displayName: t('Add a ‘None’ item?'),
        default: false,
        category: 'choices',
        visibleIndex: 5
      }, {
        name: 'noneText',
        displayName: t('None Item Text'),
        category: 'choices',
        visibleIndex: 6,
        type: 'dependencyItemCustom'
      }, {
        name: 'choicesFromQuestionMode',
        displayName: t('Field Choices Mode'),
        category: 'choices',
        visibleIndex: 11
      }, {
        name: 'choicesOrder',
        category: 'choices',
        visibleIndex: 12
      },
      // validation
      {
        name: 'requiredErrorText',
        displayName: t('Required Error Text'),
        category: 'validation'
      }, {
        name: 'choicesVisibleIf',
        displayName: t('Choices visible if'),
        category: 'logic'
      }, {
        name: 'defaultValueExpression',
        displayName: t('Default value expression'),
        category: 'logic'
      }, {
        name: 'choicesEnableIf',
        displayName: t('Choices enable if'),
        category: 'logic'
      }, {
        name: 'hideIfChoicesEmpty',
        displayName: t('Hide if choices empty'),
        category: 'logic'
      }], function () {
        var radioGroupModel = new SingleQuestionRadiogroupModel('');
        if (isAddDefault) {
          var item1 = new Survey.ItemValue(t('item1'));
          var item2 = new Survey.ItemValue(t('item2'));
          var item3 = new Survey.ItemValue(t('item3'));
          radioGroupModel.choices.push(item1);
          radioGroupModel.choices.push(item2);
          radioGroupModel.choices.push(item3);
          radioGroupModel.newValue = item3;
        }
        return radioGroupModel;
      }, 'radiogroup');
    },
    isDefaultRender: true,
    afterRender: function afterRender(question) {
      var internalQuestion = question;
      if (!question.isDesignMode) {
        internalQuestion.otherPlaceHolder = 'Enter other answer (please specify)';
        // other's comment is using as value of question
        internalQuestion.storeOthersAsComment = false;
      }
    }
  };
  Survey.CustomWidgetCollection.Instance.addCustomWidget(widget, 'singleradio');
};
exports.SingleRadioToolbox = SingleRadioToolbox;
var defineRadioGroupCSS = function defineRadioGroupCSS(survey) {
  survey.onUpdateQuestionCssClasses.add(function (_, options) {
    var classes = options.cssClasses;
    if (options.question.getType() === 'radiogroup') {
      classes.mainRoot = "".concat(classes.mainRoot, " sv-question-custom");
      classes.root = 'sd-selectbase';
      classes.item = 'sd-item sd-radio sd-selectbase__item';
      classes.itemNone = 'sd-radio--none';
      classes.itemDisabled = 'sd-item--disabled sd-radio--disabled';
      classes.itemChecked = 'sd-item--checked sd-radio--checked';
      classes.itemHover = 'sd-item--allowhover sd-radio--allowhover';
      classes.itemInline = 'sd-selectbase__item--inline';
      classes.label = 'sd-selectbase__label';
      classes.labelChecked = '';
      classes.itemControl = 'sd-visuallyhidden sd-item__control sd-radio__control';
      classes.itemDecorator = 'sd-item__svg sd-radio__svg';
      classes.controlLabel = 'sd-item__control-label';
      classes.materialDecorator = 'sd-item__decorator sd-radio__decorator';
      classes.other = 'sd-comment sd-question__other';
      classes.column = 'sd-selectbase__column';
    }
  });
};
exports.defineRadioGroupCSS = defineRadioGroupCSS;